export default class Login {
    constructor() {
        this.addEvents();
    }

    addEvents() {

        var english = /^[a-zA-Z0-9;,.!@#$%:{}[]?"^&*()']*|[^&;<>`]*$/;

        // if($('section').hasClass('login-page')){
        //     $('body').addClass('hidden-scroll');
        // }

        $('.login-page__input input').on('input', function (e){
            $(this).removeClass('error already notfind');
        })

        $('.login-page__apply').on('click', function (e){
            e.preventDefault();

            let error = 0;
            let email = $('.login-page__email');
            let pass = $('.login-page__pass');

            if(email.val() && email.val().length > 2){
                email.removeClass('error already');
            }else{
                email.addClass('error already');
                error++;
            }

            if(pass.val().length >= 6){
                pass.removeClass('error already');
            }else{
                pass.addClass('error already');
                error++;
            }

            if(error == 0) {
                var ajaxurl = myAjax.ajaxurl;
                jQuery.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    data: {
                        "action": "ajax_login",
                        username: email.val(),
                        password: pass.val(),
                        course_start: localStorage.getItem('courseStart'),
                    },
                    success: function (response) {
                        let resp = JSON.parse(response);
                        if (resp.username) {
                            email.removeClass('error already notfind');
                        } else {
                            email.addClass('error already notfind');
                        }
                        if (resp.loggedin) {
                            if(localStorage.getItem('courseReturn')){
                                if($('html').attr('lang') == 'he-IL'){
                                    window.open('/he/my-account/', '_blank');
                                }else{
                                    window.open('/my-account/', '_blank');
                                }
                                window.location = localStorage.getItem('courseReturn');
                                localStorage.removeItem('courseReturn');
                                localStorage.removeItem('courseStart');
                            }else{
                                if($('html').attr('lang') == 'he-IL'){
                                    window.location = '/he/my-account';
                                }else{
                                    window.location = '/my-account';
                                }
                            }
                        } else {
                            pass.addClass('error already notfind');
                        }
                    }
                });
            }

        })

        $('.login-page__forgot').on('click', function (e){
            e.preventDefault();

            let error = 0;
            let email = $('.login-page__email');

            if(email.val() && email.val().length > 2){
                email.removeClass('error already');
            }else{
                email.addClass('error already');
                error++;
            }

            if(error == 0) {
                var ajaxurl = myAjax.ajaxurl;
                jQuery.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    data: {
                        "action": "ajax_forgot",
                        username: email.val(),
                    },
                    success: function (response) {
                        let resp = JSON.parse(response);

                        if (resp.username) {
                            email.removeClass('error already');
                        } else if(!resp.loggedin){
                            email.addClass('error already notfind');
                        }
                        if (resp.loggedin) {
                            if($('html').attr('lang') == 'he-IL') {
                                window.location = '/he/';
                            }else{
                                window.location = '/';
                            }
                        }
                    }
                });
            }

        })

        $('.login-page__forgot-save').on('click', function (e){
            e.preventDefault();

            let password = $('.login-page__pass');
            let newPass = password.val();
            let error = 0;

            if (newPass && newPass.length >= 6) {
                password.removeClass('error');
                $('.password-error').css('display', 'none')
            } else {
                password.addClass('error');
                $('.password-error').css('display', 'block');
                error++;
            }

            if (error === 0) {
                $.ajax({
                    type: 'POST',
                    url: myAjax.ajaxurl,
                    data: {
                        action: 'reset_password_custom',
                        password: newPass,
                        key: getQueryParam('key'),
                        login: getQueryParam('login'),
                    },
                    success: function (response) {
                        if (response.success) {
                            $('.password-error').css('display', 'none')
                            if($('html').attr('lang') == 'he-IL') {
                                window.location = '/he/login';
                            }else{
                                window.location = '/login';
                            }
                        } else {
                            alert(response.message);
                            $('.password-error').html(response.message);
                            $('.password-error').css('display', 'block');
                        }
                    }
                });
            }
        });

        function getQueryParam(name) {
            let url = new URL(window.location.href);
            return url.searchParams.get(name);
        }


        $('.register-email').on('click', function (e) {
            e.preventDefault();
            $('.login-page__title').html(AssetsPath.translations.signupText);
            $('.login-page__free, .login-page__social').addClass('hide');
            $('.login-page__form').removeClass('hide');
            $('.login-page__bottom a').html(AssetsPath.translations.backSignupText);
        });

        $('.login-page__checkbox div').on('click', function (e) {
            $(this).hasClass('active') ? $(this).removeClass('active') : $(this).addClass('active');
        });

        $('.login-page__input svg').on('click', function (e) {
            let input = $(this).parents('.login-page__input').find('input');
            if(input.attr('type') == 'text'){
                input.attr('type', 'password');
            }else{
                input.attr('type', 'text');
            }
        });

        function getPushEngageId() {
            return new Promise((resolve, reject) => {
                PushEngage.push(function () {
                    PushEngage.getSubscriberId()
                        .then(function (subscriberId) {
                            resolve(subscriberId);
                        })
                        .catch(function (err) {
                            resolve('');
                        });
                });
            });
        }


        $('.login-page__reg').on('click', function (e){
            e.preventDefault();

            let error = 0;
            let email = $('.login-page__email');
            let username = $('.login-page__username');
            let firstname = $('.login-page__firstname');
            let lastname = $('.login-page__lastname');
            let pass = $('.login-page__pass');
            let passrepeat = $('.login-page__passrepeat');

            username.removeClass('already');

            if (english.test(username.val()) && username.val().length >=2){
                username.removeClass('error already');
            }else{
                username.addClass('error already');
                error++;
            }

            if(isEmail(email.val())){
                email.removeClass('error');
                email.removeClass('notvalid');
            }else{
                email.addClass('error');
                email.addClass('notvalid');
                error++;
            }

            if(firstname.val().length >=2){
                firstname.removeClass('error already');
            }else{
                firstname.addClass('error already');
                error++;
            }

            if(lastname.val().length >=2){
                lastname.removeClass('error already');
            }else{
                lastname.addClass('error already');
                error++;
            }

            if(pass.val().length >= 6){
                pass.removeClass('error already');
            }else{
                pass.addClass('error already');
                error++;
            }

            if(pass.val() == passrepeat.val()){
                passrepeat.removeClass('error');
                $('.login-page__cols').removeClass('not_equal');
            }else{
                passrepeat.addClass('error');
                $('.login-page__cols').addClass('not_equal');
                error++;
            }

            if(error == 0) {
                getPushEngageId().then(profilePush => {
                    var ajaxurl = myAjax.ajaxurl;
                    jQuery.ajax({
                        type: 'POST',
                        url: ajaxurl,
                        data: {
                            "action": "ajax_add_user",
                            email: email.val(),
                            password: pass.val(),
                            username: username.val(),
                            firstname: firstname.val(),
                            lastname: lastname.val(),
                            check: $('.login-page__checkbox div').hasClass('active') ? 1 : 0,
                            profile_id: profilePush,
                            lang: $('html').attr('lang') == 'he-IL' ? 'he' : 'en',
                            course_start: localStorage.getItem('courseStart')
                        },
                        success: function (response) {
                            let resp = JSON.parse(response);

                            if (resp.username && !resp.reg) {
                                username.addClass('error already notfind');
                            } else if(resp.email && !resp.reg) {
                                email.addClass('error already notfind');
                            }
                            else {
                                username.removeClass('error');
                                username.removeClass('already');
                                email.removeClass('error');
                                email.removeClass('already');
                            }

                            if (resp.reg) {
                                if(localStorage.getItem('courseReturn')){
                                    if($('html').attr('lang') == 'he-IL') {
                                        window.open('/he/welcome-a-user/', '_blank');
                                    }else{
                                        window.open('/welcome/', '_blank');
                                    }
                                    window.location = localStorage.getItem('courseReturn');
                                    localStorage.removeItem('courseReturn');
                                    localStorage.removeItem('courseStart');
                                }else{
                                    if($('html').attr('lang') == 'he-IL') {
                                        window.location = '/he/welcome-a-user/';
                                    }else{
                                        window.location = '/welcome/';
                                    }
                                }
                            }
                        }
                    });
                });
            }

        })


        $('.myAccount__input input').on('input', function (e){
            $('.myAccount__buttons div.disabled').removeClass('disabled');
        })


        // $('.myAccount__buttons div:nth-child(1)').on('click', function (e){
        //     e.preventDefault();
        //     $('.myAccount__input input').each(function (ii,ee){
        //         let defVal = $(this).attr('data-default');
        //         defVal ? $(this).val(defVal) : '';
        //     })
        //     $('.myAccount__buttons div:nth-child(1)').addClass('disabled');
        // })





        $('.login-page__bottom a').on('click', function (e){
            e.preventDefault();
            if(!$(this).parents('.register-page').find('.login-page__form').hasClass('hide') && $(this).parents('.login-page ').hasClass('register-page')){
                $('.login-page__title').html(AssetsPath.translations.freeSignupText);
                $('.login-page__free, .login-page__social').removeClass('hide');
                $('.login-page__form').addClass('hide');
                $('.login-page__bottom a').html(AssetsPath.translations.hadranBack);
            }else{
                window.location = $(this).attr('href');
            }
        })

        function isEmail(email) {
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email);
        }

    }
}